import { Gender } from "./moov-common/enum/gender.enum";
import { Locale } from "./moov-common/enum/locale.enum";

export default {
    sendAnalytics: true,
    logGA:true,
    defaultGender: Gender.MALE,
    defaultLocale: Locale.en_US,
    supportedLocales : [Locale.en_US, Locale.he_IL],
    translationFilesRegEx: '^(\/assets\/i18n\/en\-US\.json)|^(\/assets\/i18n\/he\-IL\.json)$',
    logoutMsgClose: 1000,
    userMessageTimeClose: 4000,
    userPayAttentionScoreThreshold: 85,
    present_guided_tours: false,
    relationshipSkiplistTTL_hours: 24,
    rediscoverMinimalScoreToContinue: 11,
    maxGapFactor: 5
}